import { faRefresh } from '@fortawesome/free-solid-svg-icons';

import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AuthService, NotificationService } from '@core/services';

import { ResetData } from '@shared/types';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    standalone: false,
})
export class PasswordResetComponent {
    public resetForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
    });
    busy = false;
    success = false;
    public loadingIcon = faRefresh;

    constructor(private authService: AuthService, private notificationService: NotificationService) {}

    onSubmit() {
        this.busy = true;
        let data = this.resetForm.value as ResetData;
        this.authService.requestResetPasswordEmail(data.email).subscribe({
            next: () => {
                this.busy = false;
                this.success = true;
            },
            error: (err: Error) => {
                console.error('Something went wrong while requesting new password:', err);
                this.notificationService.errorMessage('Password reset failed, please try again later.');
                this.busy = false;
            },
        });
    }
}
